import { render, staticRenderFns } from "./Userpage.vue?vue&type=template&id=5fc8828e&"
import script from "./Userpage.vue?vue&type=script&lang=js&"
export * from "./Userpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports